import {
  GET_SKULOOKUP_REPORT_REQUEST,
  GET_SKULOOKUP_REPORT_SUCCESS,
  GET_SKULOOKUP_REPORT_ERROR,
} from "./types";
import axios from "axios";
import { BASEURL } from "../../constant/config.js";


export const getskuloopup = (token, values) => (dispatch) => {
  dispatch({ type: GET_SKULOOKUP_REPORT_REQUEST });
  return axios({
    method: "POST",
    url: `${BASEURL}getAll/Skulookupreport`,
    headers: {
      Accept: "application/json",
      Authorization: "Bearer " + token,
    },
    data: values, 
  })
    .then((response) => {
      return dispatch({
        type: GET_SKULOOKUP_REPORT_SUCCESS,
        payload: response.data,
      });
    })
    .catch((error) => {
      dispatch({
        type: GET_SKULOOKUP_REPORT_ERROR,
        payload: [],
      });
      
      
      
      
      
      
      
      
      
      
    });
};
